export default __webpack_public_path__ + "static/media/PatientDuplicateReport.1ef15210.svg";